export default {
  START: '/provider',
  CONTINUE: '/provider/continue',
  EXISTING_ACCOUNT: '/provider/existing-account',
}
